export default __webpack_public_path__ + "static/media/2---PRESTIGIO-MESH---120x278-Lucido.edc6e9ba.jpg";